/**
 * Interval of milliseconds that should pass between another attempt to check.
 */
const CHECK_INTERVAL_MILLIS = 300;
/**
 * Number of max retries to check for the initialization of the youtube lyte
 * script.
 */
const MAX_RETRIES = 30;

class YoutubeLyteInitializer {
  state: 'initial' | 'checking' | 'done' = 'initial';
  intervalId: number | undefined;
  retries: number = 0;

  initializeYoutubeLyte(): boolean {
    // Check that the script was loaded properly
    // Initialize WP YouTube Lyte on pages that are lazy loaded by turbolinks
    // See: https://wordpress.org/plugins/wp-youtube-lyte/
    // @ts-ignore
    if (window.hasOwnProperty('ly') && typeof window.ly.te === 'function') {
      // @ts-ignore
      window.ly.te();
      return true;
    }

    return false;
  }

  checkInitializationStatus = (): boolean => {
    if (this.initializeYoutubeLyte() || this.retries > MAX_RETRIES) {
      clearInterval(this.intervalId);
      this.state = 'done';
      return true;
    }

    this.retries++;
    return false;
  };

  check(): void {
    // When the script has been loaded already, only call the initializer
    if (this.state === 'done' && this.initializeYoutubeLyte()) {
      return;
    }

    if (this.state !== 'initial') {
      return;
    }

    // Do an initial checkup before starting the interval
    this.state = 'checking';
    if (this.checkInitializationStatus()) {
      this.state = 'done';
      return;
    }

    // Start the interval
    this.intervalId = setInterval(
      this.checkInitializationStatus,
      CHECK_INTERVAL_MILLIS
    );
  }
}

export { YoutubeLyteInitializer };
